import { SxProps, Theme } from '@mui/material';

export const stickyScreenHeaderSx: SxProps<Theme> = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  bgcolor: 'custom.layout.workspace',
};
